export function fieldLabel(field: string): string {
    const label = field.replace(/[_-]+/g, ' ').trim()
    return label.charAt(0).toUpperCase() + label.slice(1)
}
